<template>
  <div class="mb-0 account-switch-dropdown" @click="addListener">
    <!-- Selected Account Section  -->
    <v-btn class="py-4 account-toggle-btn" @click="toggleSelect" text>
      <span class="account-selected">{{ selectedAccount.name }}</span>
      <v-icon v-if="!showAccountsMenu" color="#616161" class="mr-arrow pl-2">
        {{ menuIcon }}
      </v-icon>
      <template v-slot:loader> </template>
    </v-btn>
    <v-progress-linear
      dark
      v-if="isLoading"
      color="secondary"
      height="2"
      indeterminate
    ></v-progress-linear>

    <v-select
      filled
      item-color="#00000014"
      ref="select"
      background-color="#FFFFFF"
      :items="items"
      height="60px"
      class="
        text-capitalize
        mt-1
        py-0
        secondary--font
        d-none d-md-flex
        mb-2
        account-dropdown
      "
      item-text="name"
      :menu-props="{
        offsetY: true,
        maxHeight: 250,
        openOnClick: showAccountsMenu,
      }"
      color="#616161"
      return-object
      :loading="isLoading"
    >
      <template
        v-slot:prepend-item
        v-if="$store.getters['auth/account'].list.length"
      >
        <v-list-item>
          <v-list-item-content>
            <v-text-field
              dense
              hide-details
              ref="searchInputField"
              prepend-inner-icon="mdi-magnify"
              outlined
              v-model="searchString"
              placeholder="Search Accounts"
              @input="searchAccount"
              class="search-account-pd-br mb-1"
            />
          </v-list-item-content>
        </v-list-item>
      </template>
      <template #item="{ item, on, attrs }">
        <v-list-item
          style="min-height: 36px !important"
          @click="switchAccount(item)"
          v-bind="attrs"
          v-track="`switch-acount-to-${item.id}`"
        >
          <v-list-item-content class="body-2 white mx-3">
            {{ item.name }}
          </v-list-item-content>
          <v-progress-circular
            v-if="item.id == loadingAccount"
            indeterminate
            size="20"
            width="2"
            color="primary"
          ></v-progress-circular>
          <v-icon v-if="item.error" color="red">
            mdi-alert-circle-outline
          </v-icon>
        </v-list-item>
      </template>
      <template #no-data>
        <v-list-item>
          <v-list-item-content class="body-2 mx-2 justify-center">
            No Account Found
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-select>
  </div>
</template>

<script>
import { $accounts } from "@core/services/";
import { mapGetters, mapActions } from "vuex";
import { sanitiseAccountList, _debounce } from "@core/config/utils";
export default {
  name: "MAccountsDropdown",
  data() {
    return {
      isSwitchingAccount: false,
      loadingAccount: 0,
      fetchedItems: [],
      searchedItems: [], 
      searchString: "",
      totalAccounts: 0,
      isLoading: false,
      isClosed: true,
    };
  },
  mounted() {
    if(this.$keycloak && this.$keycloak.token){
      if(this.account.list.length >= this.params.per_page){
        this.fetchAccounts({
          per_page: (this.params.page + 1) * this.params.per_page,
          page: 1
        })
      }else{
        this.fetch();
      }
    }
  },
  computed: {
    ...mapGetters({
      account: "auth/account"
    }),
    params: {
      get() {
        return this.account.pagination;
      },
      set(value) {
        this.$store.commit("auth/account.pagination", value);
      },
    },
    selectedAccount() {
      return (
        this.account.current || {
          name: "",
          id: 0,
        }
      );
    },
    /** 
     * Set the Items Array on the basis of search string
     * else it will show all the results
     */
    items: {
      get() {
        return this.searchString
          ? this.searchedItems
          : this.account.list;
      },
      set(value) {
        let accounts = this.account.list;
        value.forEach(acc => {
            let account = accounts.find(i=> i.id == acc.id)
            if(account){
              Object.assign(account, acc)
            }
        });
        accounts = accounts.concat(value);
        this.$store.commit("auth/account.list", accounts);
      },
    },
    showAccountsMenu: {
      cache: false,
      get() {
        return this.account.list.length < 2;
      },
    },
    /**
     * Get dropdown menu icon
     */
    menuIcon: {
      cache: false,
      get: function () {
        return this.$refs.select && this.$refs.select.isMenuActive
          ? "mdi-menu-up"
          : "mdi-menu-down";
      },
    },
  },
  methods: {
    ...mapActions({getAccountInfo: 'auth/getAccountInfo'}),
    fetch() {
      let queryParams = {};
      if (this.searchString) {
        queryParams = {
          name_cont: this.searchString,
        };
      } else {
        let page = this.items.length
          ? Math.ceil(this.items.length / this.params.per_page)
          : 0;
        this.items.length % this.params.per_page == 0 && page++;
        this.params.page = page;
        queryParams = {
          page: this.params.page,
          per_page: this.params.per_page,
        };
      }

      this.fetchAccounts(queryParams);
      
    },
    fetchAccounts(params){
      $accounts.fetch({ params: params }).then((res) => {
        const accountList = sanitiseAccountList(res.data.data);
        if (this.searchString && accountList) {
          this.searchedItems = accountList;
        } else {
          this.items = accountList;
        }
        let meta = res.data.meta;
        this.totalAccounts = meta.total;
        this.totalPages = Math.ceil(meta.total / this.params.per_page);
      }).finally(() => {
        this.isLoading = false;
      });
    },
    /**
     * Search account from list and From Database through API
     */
    searchAccount() {
      if (!this.isLoading) {
        _debounce(() => {
          this.fetch();
        }, 500)();
        this.isLoading = true;
      }
    },
    addListener(){
      this.selectorClass = ".v-menu__content";
      var el = document.querySelector(this.selectorClass);
      /** add scroll event **/
      if (el) {
        this.isClosed = false;
        el.addEventListener("scroll", this.onScroll);
      }
    },
    onScroll({ target: { scrollTop, clientHeight, scrollHeight } }) {
      if (scrollTop + clientHeight >= scrollHeight) {
        if (this.totalAccounts > this.items.length) {
          this.fetch();
        }
      }
    },
    switchAccount(account) {
      let THIS = this;
      if(this.isSwitchingAccount || account.id == this.selectedAccount.id) return
      this.isSwitchingAccount = true
      
      // alert(process.env.VUE_APP_PRODUCT)
      let product = window.location.pathname.split('/')[1];
      if(
        !["service","commerce","settings"].includes(product) ||
        (product == 'service' && !account.enable_service)
      ){
        product = 'accounts'
      }

      this.loadingAccount = account.id
      this.$refs.select.isFocused = false;

      let index = this.account.list.findIndex(i=>i.id == account.id)
      if(index == -1){
        this.items = [account]
      }

      this.getAccountInfo({
        accountId: account.id, 
        cluster: account.cluster,
        successHandler:() => {
          THIS.isSwitchingAccount = false
          THIS.loadingAccount = 0
          window.location.href= `/${product}/${account.id}/dashboard`
        },
        errorHandler:() => {
          THIS.loadingAccount = 0
          THIS.isSwitchingAccount = false
          account.error = true
        }
      });
    },
    /**
     * Toggle select (open/close select menu)
     */
    toggleSelect() {
      const el = this.$refs.select.$el;
      if (!this.$refs.select.isMenuActive) {
        this.searchString = "";
        !this.showAccountsMenu && this.$refs.select.onClick(el);
      } else {
        this.$refs.select.onBlur(el);
        this.searchString = "";
      }
    },
  },
};
</script>
<style scoped lang="scss">
.account-switch-dropdown .v-progress-linear {
  margin-top: -2px;
}

.v-btn.account-toggle-btn {
  height: auto;
  background: transparent;
  border-radius: 0px;
}
.account-selected {
  width: max-content;
  text-transform: capitalize;
  line-height: 2.3;
  color: rgba(0, 0, 0, 0.87);
  font-size: 14px;
  font-weight: 600;
}
.account-dropdown::v-deep .v-input__control {
  visibility: hidden !important;
  margin-top: -4rem;
}
.account-dropdown.v-select:link {
  color: #191919;
}
.account-dropdown {
  font-weight: 600 !important;
  letter-spacing: 0.55px;
  font-size: 13px !important;
}
.account-dropdown.v-select.v-text-field--enclosed:not(.v-text-field--single-line):not(.v-text-field--outlined)
  .v-select__selections {
  padding-top: 0px;
}
.account-dropdown .v-text-field > .v-input__control > .v-input__slot:before,
.v-text-field > .v-input__control > .v-input__slot:after {
  content: none !important;
}
.account-dropdown
  .v-input__control
  > .v-input__slot
  > .v-select__slot
  > .v-select__selections
  > .v-select__selection {
  overflow: inherit !important;
}
.account-dropdown.v-select.v-text-field input {
  width: 0px;
}
</style>
